import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Note } from '../models/note.model';
import { Activity } from '../models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private apiUrl = environment.apiUrl + '/Notes';

  http = inject(HttpClient);

  constructor() {}
  createNote(note: Note): Observable<Activity> {
    return this.http.post<Activity>(`${this.apiUrl}/CreateNote`, note);
  }
}
